import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ResortComponent } from '../shared/resort.component';
import { QueryParamService, Core, LabelNames, ApplicationConfiguration, Member } from '../shared/core/ovs.core';
import { Router } from '@angular/router';
import { ConfirmationPageEvents, ResortPageViews } from '../instrumentation/resort-custom-events';
import { UserActivityLogger, UserActivityLoggerOptions, UserActivityPublishDataTypes } from '../instrumentation/user-activity-logger.service';
import { ResortCheckoutLabelNames } from './resort-checkout-label-names';
import { MemberClient } from '../services/member-info.client';
import {ResortApplicationConfiguration} from '../models/presentation.model';



@Component({
  selector: 'confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ConfirmationComponent extends ResortComponent
{
    discount: number;
    discountPrice: number;
    purchaseTypeId: number;
    priceWithTaxesAndFees: number;
    percentBadgeLabelText: string;
    private memberInfoClient: MemberClient;
    private resortCore: Core;
   

    public getLabel(key: string): string {
        const contextKey = ResortCheckoutLabelNames[key];
        return Core.current.getLabel(contextKey);
    }
    
    public get vacationCashDiscount(): number{
        return this.application.currentBooking.VacationCashDiscount;
    }

    public get showCertRedemptionFee(): boolean{
        return this.application.currentInventory.certificateRedemptionFee > 0;
      }

    public get hasCert(): boolean{
        var cert = this.qryParamService.certnumber();
        return cert!==undefined && cert!==null && cert !=="";
    }

      public resortHasAllInclusiveRules(): boolean{
        return this.application.currentResort.resortAllInclusiveRuleList && this.application.currentResort.resortAllInclusiveRuleList.count() > 0 ;
    }

    constructor(private qryParamService: QueryParamService, private router: Router, core: Core, memberClient: MemberClient)
    {
        super();
        this.resortCore = core;
        this.memberInfoClient = memberClient;
        this.scrollToTop();
        this.subscribe(core.configuration, c => this.OnConfigurationChanged(c)); 

    }

    handleErr(e) {
        this.mapApplicationInsightsObjects(e);
    }

    public initialize(): void
    {
        try {
            super.initialize();
            this.discount = this.application.currentBooking.Discount;
            switch (this.application.currentBooking.PurchaseTypeId) {
                case 15:
                    if (this.application.currentInventory.creditsUsed) this.discount = this.application.currentInventory.creditsUsed;
                    break;
                default:
                    this.discount = this.application.currentInventory.savings;
                    break;
            }
            this.discountPrice = this.application.currentInventory.price - this.discount;
            var self = this;
            this.memberInfoClient.GetMemberInfo((r) => this.getMemberInfo(r),self.handleErr.bind(this));
        }
        catch (ex) {
            this.mapApplicationInsightsObjects(ex);
        }
	}
    
    public get coGrandTotal(): number {

        try {
            const inventory = this.application.currentInventory;
            return inventory.priceWithTaxesAndFees + inventory.insurance - this.discount + inventory.certificateRedemptionFee 
                + this.application.currentBooking.AllInclusiveFees + (this.application.currentBooking.IsUpgradeMembershipSelected ? this.application.currentBooking.UpgradeFee : 0);
        } catch (ex) {
            this.mapApplicationInsightsObjects(ex);
        }
    }

    public newBooking(): void{
        window.location.reload(true);
    }

    public closeTab():void{
        this.qryParamService.clear();
        window.close();
    }

    private OnConfigurationChanged(config: ApplicationConfiguration): void
    {
        this.percentBadgeLabelText = config.Labels ? config.Labels.firstOrDefault(l => l.Name === LabelNames.ConfirmationPercentBadgeLabel).DisplayText : '---';
    }

    private getMemberInfo(result: Member): void {
        if (result) {
            this.application.configuration.Member = result;
            UserActivityLogger.publish(this.configuration.Member, UserActivityPublishDataTypes.Member);
        }
        UserActivityLogger.logPageView(ResortPageViews.ConfirmationPage, UserActivityLoggerOptions.Both, {
            order_id: this.application.bookingCompletion.bookingNumber,
            bookingid: this.application.bookingCompletion.bookingNumber
        });
    }

    private mapApplicationInsightsObjects(ex) {
        const mapData = new Map();
        mapData.set("memberid", this.application.configuration.Member.Id);
        mapData.set("ovcpartner", this.application.configuration.Partner.LongName);
        mapData.set("ovcpartnerid", this.application.configuration.Partner.Id);
        mapData.set("memberclass", this.application.configuration.MemberClass);
        mapData.set("bookingnumber", this.application.bookingCompletion.bookingNumber);
        mapData.set("bookingid", this.application.bookingCompletion.bookingNumber);
        mapData.set("product", "Resort");
        mapData.set("errormessage", ex.message ? ex.message : "Confirmation exception unknown");
        mapData.set("httperrorcode", ex.code ? ex.code : "");
        mapData.set("origination", "ICE");
        let jsonObject = {};
        mapData.forEach((value, key) => {
            jsonObject[key] = value;
        });
       
        UserActivityLogger.logEvent(ConfirmationPageEvents.ConfirmationFailure, jsonObject, UserActivityLoggerOptions.AppInsightsOnly);
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/check-out/confirmation.component.ts